var exports = {
  "oq": "LexicalSearchInput.module__editorShell___UVdING",
  "LL": "LexicalSearchInput.module__editable___UVdING",
  "FY": "LexicalSearchInput.module__paragraph___UVdING",
  "bI": "LexicalSearchInput.module__tokenBase___UVdING",
  "bV": "LexicalSearchInput.module__tokenKey___UVdING",
  "vA": "LexicalSearchInput.module__tokenValue___UVdING",
  "eT": "LexicalSearchInput.module__tokenUnapplied___UVdING",
  "GU": "LexicalSearchInput.module__tokenExclude___UVdING",
  "qf": "LexicalSearchInput.module__placeholder___UVdING",
};

module.exports = exports;
